import { navigationPaths } from '../constants/paths'

export function navigateTo(path) {
  this.props.history.push({
    pathname: navigationPaths[path]()
  })
}

export function activeAdminLink(path) {
  let host
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3001'
  }
  else {
    host = `https://${window.location.hostname.replace('internal', 'api')}`
  }

  return `${host}/admin` + (path[0] === '/' ? path : `/${path}`)
}
